export enum NavbarNavMenuLevel {
    first = 1,
    second,
    third,
}